import type { FaireProductEntity } from "../../entity_types/product";

export const p_cynbqbj2ch: FaireProductEntity = {
  token: "p_cynbqbj2ch",
  type: "product",
  name: "18k Gold Plated Herringbone flat necklace chain",
  brandToken: "b_64gjnxjyb8",
  brandName: "Karrbear",
  imageUrl:
    "https://cdn.faire.com/fastly/2978ce23203da7f6a9c16f8b7478dd899db92e46f84b8aae26476aae89f320d5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4deae87110854e80e0186bab3819cecde4ecba20f75f3f4ffb7703768597bb7.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "18k Gold Plated Herringbone flat necklace chain\nLength 8'' 10''16'' 18''20''24''",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:18.611Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
